import com from "./common";
import CONFIG from "@/util/config";
import store from "@/store";
import { getUserInfo, userLogin } from "@/service/index";
// let wx_config = {
//   appid: "wx314a602f2412b294",
//   secrect: "0dc90604b8bd9c83222dc22419a7fee3"
// };
let wx_config = {
  appid: "wx05730957bc0a84f4",
  secrect: "02c552f48192af00720efee6d0cc649a"
};
// 获取微信code
const getWXCode = () => {
  return new Promise((resolve, reject) => {
    // 没有code 时授权获取微信code
    let _window = window.location.href;
    let code = getQueryString("code");
    if (com.isWechatBrowsers()) {
      if (!getQueryString("code")) {
        // 第一次进入页面，拉取微信授权
        const newUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${
          wx_config.appid
        }&redirect_uri=${encodeURIComponent(
          _window
        )}&response_type=code&scope=snsapi_userinfo&state=STATE&connect_redirect=1#wechat_redirect`;
        window.location.href = newUrl;
      } else {
        getOpenId(code);
      }
    }
    // if (com.isWechatBrowsers()) {
    //   if (code == null || code === "") {
    //   } else {
    // getOpenId(code);
    //   }
    // }
  });
};
// 校验是否存在code
const getQueryString = (name: any) => {
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
  let r = window.location.search.substr(1).match(reg); //匹配目标参数
  if (r != null) return unescape(r[2]);
  return null; //返回参数值
};
// 截取code
const getUrlParam: any = (parameName: any) => {
  let parames = window.location.search;
  if (parames.indexOf(parameName) > -1) {
    let parameValue = "";
    parameValue = parames.substring(
      parames.indexOf(parameName),
      parames.length
    );
    // 检测后面是否还有参数
    if (parameValue.indexOf("&") > -1) {
      // 去除后面多余的参数，得到最终parameName = parameValue 形式的值
      parameValue = parameValue.substring(0, parameValue.indexOf("&"));
      // 去掉参数名，得到最终纯值字符串
      parameValue = parameValue.replace(parameName + "=", "");
      return parameValue;
    }
    return "";
  }
};
const getOpenId = (code: any) => {
  return new Promise((resolve, reject) => {
    let openid = localStorage.getItem("openid");
    getUserInfo({ code: code }).then((res: any) => {
      if (res.status === 200) {
        getLogin(res.data.openid);
      } else if (res.status == -205) {
        getLogin(openid);
      } else {
        window.location.href = "https://yty.smarttourisms.com/dist/";
      }
    });
  });
};

const getLogin = (openId: any) => {
  return new Promise<void>(async (resolve, reject) => {
    userLogin({ openId: openId }).then(async res => {
      if (res.status === 200) {
        if (res.data && res.data.token) {
          localStorage.setItem("openid", res.data.personal.openId);
          localStorage.setItem("userName", res.data.personal.userName);
          localStorage.setItem("gender", res.data.personal.gender);
          localStorage.setItem("phone", res.data.personal.phone);
          localStorage.setItem("headImg", res.data.personal.headImg);
          localStorage.setItem("token", res.data.token);
          resolve();
        }
      }
    });
  });
};

export default {
  // 获取用户信息
  getUserInfo() {
    return new Promise<void>(async (resolve, reject) => {
      getWXCode();
      // getUserInfo().then(async (res) => {
      //   if (res.status !== 200 && com.isWechatBrowsers()) {
      //     // 拉取微信授权
      //     getWXCode()
      //   } else if (res.status === 200) {
      //     // 设置用户信息
      //     // 判断有没有token，没有则表示第一次进入页面，需存入临时token
      //     if(!localStorage.getItem('token')){
      //       localStorage.setItem('token',res.data.token)
      //     }
      //     localStorage.setItem('vcode',res.data.vcode);
      //     localStorage.setItem('jpjsOpenId', res.data.jpjsOpenId || ""); // 金牌解说openId
      //     resolve()
      //   }
      // })
    });
  }
};
